import api from "./axiosConfig";

export const getHeader = async () => {
  const res = await api.get("Home/header/");
  return res.data[0]; // backend returns array
};

// New function for Hero section
export const getHero = async () => {
  const res = await api.get("Home/herotextoverlay/"); // make sure this is the correct endpoint
  return res.data[0]; // returns first active hero
};

// About
export const getAbout = async () => {
  const res = await api.get("Home/about/");
  return res.data; // backend returns array of active About items
};


export const getFunFacts = async () => {
  const res = await api.get("Home/funfact/");
  return res.data[0]; // backend returns array → take first active record
};


export const getTestimonials = async () => {
  const res = await api.get("Home/testimonial/");
  return res.data; // backend returns an array of testimonial objects
};


export const getHomeBlogs = async () => {
  const res = await api.get("Home/homeblog/");
  return res.data; // returns array of HomeBlog objects with cards
};


export const getFooter = async () => {
  const res = await api.get("Home/footer/");
  return res.data[0]; // backend returns array with one active footer
};


export const getUpcomingProjects = async () => {
  const res = await api.get("Home/upcoming/");
  return res.data; // backend returns array of Upcoming objects with nested upcomingprojects
};
